// extracted by mini-css-extract-plugin
module.exports = {"root":"LocationPageDesktop_root__37x6k","page":"LocationPageDesktop_page__2RZ8l"};